import { RootState } from 'store';
import { createSelector } from '@reduxjs/toolkit';
import { PERMISSIONS } from 'common/constants/permissions';
import { checkIsLoading, checkIsLoadingDone, checkIsLoadingError } from 'common/utils/checkLoading';

import { useSelector } from 'react-redux';

import { STATE } from '../types/state';

type Permissions = {
  [key in keyof typeof PERMISSIONS]: boolean;
};

export const permissions = createSelector(
  (state: RootState) => state[STATE].permissions.data || [],
  userPermissions => Object.keys(PERMISSIONS)
    .reduce((acc, permissionName) => {
      const hasPermission = !!userPermissions.find(userPermission => userPermission === PERMISSIONS[permissionName]);
      return {
        ...acc,
        [permissionName]: hasPermission
      };
    }, {} as Permissions)
);

export const useUserPermissions = () => {
  return useSelector(permissions);
};

export const usePermissionsLoadingStatus = () => {
  const permissionsLoadingStatus = useSelector((state: RootState) => state[STATE].permissions.loadingStatus);
  return permissionsLoadingStatus;
};

export const useIsPermissionsDone = () => {
  const permissionsLoadingStatus = usePermissionsLoadingStatus();
  return checkIsLoadingDone(permissionsLoadingStatus);
}

export const permissionsLoadingStatus = (state: RootState) => (
  state[STATE].permissions.loadingStatus
);

export const isPermissionsLoading = (state: RootState) => (
  checkIsLoading(permissionsLoadingStatus(state))
);

export const isPermissionsDone = (state: RootState) => (
  checkIsLoadingDone(permissionsLoadingStatus(state))
);

export const isPermissionsError = (state: RootState) => (
  checkIsLoadingError(permissionsLoadingStatus(state))
);
